import { DataStackedAttributes, DataFlattenedAttributes } from './types';

/**
 * Transforms an array of DataStackedAttributes into DataFlattenedAttributes,
 * suitable for use in Recharts components that need indexed keys (y0, y1, label0, label1, etc.).
 *
 * @param data - The input array of DataStackedAttributes.
 * @returns The transformed array of DataFlattenedAttributes.
 */
export function flattenStackedGraphData(
    data: DataStackedAttributes[]
): DataFlattenedAttributes[] {
    return data.map((item) => {
        let newItem: DataFlattenedAttributes = {
            x: item.x,
        };
        item.y.forEach((y, index) => {
            newItem[`y${index}`] = y;
            newItem[`label${index}`] = item.label?.[index] ?? `Series ${index + 1}`;
        });
        return newItem;
    });
}

// Format date as YYYY-MM-DD
export const formatDateYYYYMMDD = (value: any): string => {
    try {
        const date = new Date(value);
        if (isNaN(date.getTime())) {
            // Return the original value if it's not a valid date
            return String(value);
        }
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        return `${year}-${month}-${day}`;
    } catch (error) {
        console.error("Error formatting date:", error);
        return String(value); // Fallback to string conversion on error
    }
}; 